import { Dialog, DialogTitle, Typography, IconButton, DialogContent, Button, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Box, Stack, DialogActions } from '@mui/material';
import { X } from '../../../../assets';
import { useTranslation } from 'react-i18next';
import { ItemPreview } from '../../interfaces/ItemsPreview';
import { Section } from '../../../../components/ui/Section';
import { Pill } from '../../../../components/shared/Pill';

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  data: ItemPreview[];
  isSubmitting: boolean;
}

const SubmitWasteChecksheetModal = ({ open, onClose, onConfirm, data, isSubmitting }: Props) => {
  const { t } = useTranslation('wasteChecksheet');

  return (
    <Dialog open={open}
      maxWidth='sm'
      fullWidth
      onClose={onClose}>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center' }}>
        <Typography variant="textLG"
          fontWeight='bold'
          sx={{ display: 'flex', flex: 1, justifyContent: 'left', alignItems: 'center' }}>
          {t('create.submitData')}
        </Typography>
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 14,
            top: 10,
            color: (theme) => theme.palette.custom.gray[800],
          }}
        >
          <X />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {
          data && (
            <Section>
              {data.length > 0 ?
                <>
                  <Box sx={{ p: 4 }}>
                    <Typography sx={{ display: 'flex', alignItems: 'center' }}>
                      {t('create.tableTitle')}
                      <Pill text={`${data.length} Items`}></Pill>
                    </Typography>
                  </Box>
                  <TableContainer id='waste-items-modal-container'
                    sx={{ borderBottomRightRadius: '12px', borderBottomLeftRadius: '12px', overflow: 'hidden' }}>
                    <Table sx={{ borderBottomRightRadius: '12px', borderBottomRadius: '12px', overflow: 'hidden' }}>
                      <TableHead>
                        <TableRow>
                          <TableCell sx={{ width: '1x' }}>
                            {t('itemPreview.itemNumber')}
                          </TableCell>
                          <TableCell sx={{ width: '2x' }}>
                            {t('itemPreview.itemDescription')}
                          </TableCell>
                          <TableCell sx={{ width: '3x' }}>
                            {t('itemPreview.wasteQty')}
                          </TableCell>
                          <TableCell sx={{ width: '2x' }}>
                            {t('itemPreview.wasteReason')}
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {data.map((item, itemIndex) => (
                          <TableRow key={`${item.itemNumber}-${itemIndex}`}>
                            <TableCell>
                              {item.itemNumber}
                            </TableCell>
                            <TableCell sx={{ width: '2x' }}>
                              {item.description}
                            </TableCell>
                            <TableCell sx={{ width: '2x' }}>
                              {item.qty}
                            </TableCell>
                            <TableCell sx={{ width: '2x' }}>
                              {item.type}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </>
                :
                <Box sx={{ p: 4 }}>
                  <Typography>{t('noData')}</Typography>
                </Box>
              }
            </Section>
          )}
      </DialogContent>
      <DialogActions>
        <Stack direction={{ xs: 'column', md: 'row' }}
          sx={{ mt: 8 }}
          gap='6px'
          width='100%'>
          <Button fullWidth
            variant="secondary"
            onClick={onClose}
            autoFocus>
            {t('create.cancel')}
          </Button>
          <Button fullWidth
            variant="primary"
            onClick={onConfirm}
            disabled={isSubmitting}
            autoFocus>
            {t('submitBtn')}
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

export default SubmitWasteChecksheetModal;